define('AwaLabs.PusherBugFix.Main', [
    'jQuery'
], function AwalabsPusherBugFix(
    jQuery
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getLayout();

            layout.on('afterAppendView', function removePushing() {
                jQuery('.shopping-layout-content').removeAttr('data-pushing');
            });
        }
    };
});
